export const check = () => (
  <path
    d="M20 6L9 17l-5-5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
